import { createFileRoute, redirect } from "@tanstack/react-router";

/** Kept so old links still land. Providers are on Primary Care, institutions on Institutions,
 * pharmacies on Profile. */
export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/care-network")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/residents/$residentId/primary-care", params });
  },
});
